import React from 'react';

export default function GoogleButton({ className = '' }) {
  const handleGoogleLogin = () => {
    // Nettoyage robuste de l'URL
    let envApiUrl = process.env.REACT_APP_API_URL || "";
    
    // Supprimer les backticks, les espaces et les guillemets potentiels
    envApiUrl = envApiUrl.replace(/[`"'\s]/g, "");
    
    // Si l'URL commence par un tiret (votre bug actuel), on le retire
    if (envApiUrl.startsWith("-")) {
      envApiUrl = envApiUrl.substring(1);
    }

    let baseUrl = "";
    if (envApiUrl.startsWith("http")) {
      baseUrl = envApiUrl.replace(/\/api$/, "").replace(/\/api\/$/, "");
    } else {
      // Fallback si l'env est corrompu ou relatif
      baseUrl = window.location.origin.replace(':3000', ':8000');
    }

    // On s'assure qu'il n'y a pas de double slash à la fin avant d'ajouter le chemin
    const finalUrl = `${baseUrl.replace(/\/$/, "")}/api/auth/google`;
    
    console.log("Redirecting to Google Auth:", finalUrl);
    window.location.href = finalUrl;
  };

  return (
    <button
      type="button"
      onClick={handleGoogleLogin}
      className={`mt-6 mx-auto flex items-center gap-2 rounded-[7px] border border-[#FEA12B] bg-white px-4 py-2 text-[14px] shadow-[0_6px_16px_rgba(254,161,43,0.15)] hover:shadow-[0_8px_22px_rgba(254,161,43,0.22)] transition-shadow ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        className="h-5 w-5"
        aria-hidden="true"
      >
        <path
          fill="#FFC107"
          d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C33.046 6.053 28.769 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.651-.389-3.917z"
        />
        <path
          fill="#FF3D00"
          d="M6.306 14.691l6.571 4.818C14.655 16.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C33.046 6.053 28.769 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"
        />
        <path
          fill="#4CAF50"
          d="M24 44c4.715 0 8.985-1.802 12.231-4.743l-5.647-4.773C28.557 36.802 26.37 37.6 24 37.6 18.803 37.6 14.396 34.209 12.709 29.59l-6.49 5.01C9.5 40.556 16.227 44 24 44z"
        />
        <path
          fill="#1976D2"
          d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.07 5.484.001-.001 6.491 5.009 6.491 5.009C40.168 35.841 44 30.477 44 24c0-1.341-.138-2.651-.389-3.917z"
        />
      </svg>
      <span>Avec Google</span>
    </button>
  );
}

